import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bgBox" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "btn"
}
const _hoisted_4 = { class: "closeIcon" }

import pcBgEn from "@/assets/images/activePagePcBgEn.png";
import pcBgZh from "@/assets/images/activePagePcBgZh.png";
import mBgEn from "@/assets/mobile-images/activePageMBgEn.png";
import mBgZh from "@/assets/mobile-images/activePageMBgZh.png";
import { ref, computed, watch } from "vue";
import store from "@/store";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import i18n from "@/lang";

export default /*#__PURE__*/_defineComponent({
  __name: 'NewUserDialog',
  setup(__props) {

const $t = i18n.global.t;
const router = useRouter();
const centerDialogVisible = computed(() => store.state.isShowActivePage);
const isMobile = computed(() => !!store.state.isMobile);
const appLanguage = computed(() => store.state.appLanguage);
const gotoNewUser = () => {
  store.commit("isShowActivePage", false);
  store.commit("activePageState", true);
  document.getElementsByTagName("body")[0].classList.remove("stop-scroll-top");
  document
    .getElementsByTagName("body")[0]
    .classList.remove("stop-scroll-bottom");
  router.push({
    path: "/activePage/newUser",
  });
};
const closeed = () => {
  store.commit("isShowActivePage", false);
  store.commit("activePageState", false);
  document.getElementsByTagName("body")[0].classList.remove("stop-scroll-top");
  document
    .getElementsByTagName("body")[0]
    .classList.remove("stop-scroll-bottom");
};
// 测试按钮
// const change = () => {
//   document.body.scrollTop = document.documentElement.scrollTop = 0;
//   document.getElementsByTagName("body")[0].classList.add("stop-scroll-top");
//   store.commit("isShowActivePage", true);
//   store.commit("activePageState", false);
// };
const imgUrl = ref();
const imgWidth = ref();
const top = ref();
watch(
  () => appLanguage.value,
  () => {
    if (!isMobile.value && appLanguage.value == "zh") {
      imgUrl.value = pcBgZh;
      imgWidth.value = "290px";
      top.value = "15%";
    } else if (!isMobile.value && appLanguage.value == "en") {
      imgUrl.value = pcBgEn;
      imgWidth.value = "290px";
      top.value = "15%";
    } else if (isMobile.value && appLanguage.value == "zh") {
      imgUrl.value = mBgZh;
      imgWidth.value = "7rem";
      top.value = "30%";
    } else if (isMobile.value && appLanguage.value == "en") {
      imgUrl.value = mBgEn;
      imgWidth.value = "7rem";
      top.value = "30%";
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    center: "",
    modelValue: _unref(centerDialogVisible),
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(centerDialogVisible) ? (centerDialogVisible).value = $event : null)),
    width: imgWidth.value,
    top: top.value,
    modal: true,
    "open-delay": 500,
    "lock-scroll": false,
    "destroy-on-close": true,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "show-close": false,
    "custom-class": "newUserDialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: imgUrl.value,
          alt: "",
          class: _normalizeClass(_unref(isMobile) ? 'imgM' : ''),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (gotoNewUser()))
        }, null, 10, _hoisted_2),
        (!_unref(isMobile))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (gotoNewUser()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)("active_page.button")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_icon, {
            class: _normalizeClass(["closed", !_unref(isMobile) ? 'pcclosed' : 'mclosed']),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (closeed()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "width", "top"]))
}
}

})